/* Copyright (c) 2021, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { APP_INITIALIZER, Provider } from '@angular/core';
import { tap, catchError } from 'rxjs/operators';
import { AppConfig, defaultConfigurationProvider } from 'app-config';

import { Configuration } from './Configuration';
import { SharedStorageService } from 'shared-storage';
import { LoggingService } from 'crimson';
import { of } from 'rxjs';

const overridesBlockName = 'overrides';

export function loadOverrides(
    appConfig: AppConfig<Configuration>,
    sharedStorageService: SharedStorageService,
    loggingService: LoggingService
) {
    return () =>
        sharedStorageService
            .readBlock<Partial<Configuration>>(overridesBlockName)
            .pipe(
                tap((overrides: Partial<Configuration>) => {
                    appConfig.setOverrides(overrides);
                }),
                catchError(err => {
                    const logger = loggingService.getLogger('shared/configuration.provider');
                    logger.error('Failed to fetch overrides', err);
                    return of(true);
                })
            )
            .toPromise();
}

export const ConfigurationOverrideInitializer: Provider = {
    provide: APP_INITIALIZER,
    useFactory: loadOverrides,
    multi: true,
    deps: [AppConfig, SharedStorageService, LoggingService]
};

export const PlaytestLiveConfigProvider: Provider[] = [
    ConfigurationOverrideInitializer,
    defaultConfigurationProvider(Configuration)
];
